export const awsConfig = {
  Auth: {
    Cognito: {
      identityPoolId: process.env.REACT_APP_AUTH_IDENTITY_POOL_ID ?? '',
      userPoolId: process.env.REACT_APP_AUTH_USER_POOL_ID ?? '',
      userPoolClientId:
        process.env.REACT_APP_AUTH_USER_POOL_WEB_CLIENT_ID ?? '',
    },
  },
  Storage: {
    S3: {
      bucket: process.env.REACT_APP_STORAGE_S3_BUCKET ?? '',
      region: 'us-east-1',
    },
  },
  Analytics: {
    Pinpoint: {
      appId: process.env.REACT_APP_ANALYTICS_APP_ID ?? '',
      region: 'us-east-1',
    },
  },
}
